<div>
  <app-details-header
    [type]="typeHR"
    [header]="data.resident | fullName"
    icon="person"
    (onEdit)="onEdit()"
    [useEdit]="data.type != ResidentType.UNASSIGNED && canEdit"
  >
    <span custom-buttons *ngIf="data.type == ResidentType.UNASSIGNED && canEdit">
      <!-- prettier-ignore -->
      <a class="edit-button cursor-pointer" (click)="onLandlordEdit()">
        <mat-icon color="black" class="font-20">edit</mat-icon> {{ 'button.edit' | loc }}{{ showTenantsEdit ? ' ' + ('commLandlord.genitive' | loc) : '' }}
      </a>
      <a class="edit-button cursor-pointer" (click)="onTenantEdit()" *ngIf="showTenantsEdit">
        <mat-icon color="black" class="font-20">edit</mat-icon> {{ 'button.edit' | loc }} {{ 'tenant.genitive' | loc }}
      </a>
    </span>
    <p>
      {{ 'user.lastUpdate' | loc }}:
      <b>{{ data.resident.lastUpdate | lDate: 'dtShort' : ('label.never' | loc) }}</b>
    </p>
  </app-details-header>

  <div class="page-section">
    <app-details-section [noHeader]="true">
      <app-details-contacts
        [personalData]="data.resident"
        [canInvite]="canAuth"
        [canMessage]="canMessage"
        [canAlert]="canAlert"
        [canCall]="canCall3cx"
        [callingPhone]="calling3cxPhone"
        (phoneCall)="make3cxCall($event)"
      ></app-details-contacts>
    </app-details-section>

    <app-details-section headerKey="connection.recentCalls">
      <div class="resident-recent-connections" *ngIf="residentRecentConnections.length; else noResidentRecentConnections">
        <app-expandable-list
          [allData]="residentRecentConnections"
          [sliceLength]="3"
          [showText]="showAllResidentConnectionsText"
          [hideText]="showLessResidentConnectionsText"
          buttonClass="resident-recent-connections__toggle"
        >
          <ng-template let-connection="data" let-last="last">
            <div class="resident-recent-connections__row" [class.resident-recent-connections__row--last]="last">
              <div
                class="resident-recent-connections__icon"
                [ngClass]="'resident-recent-connections__icon--' + getResidentConnectionToneForConnection(connection)"
              >
                <mat-icon>{{ connection.direction | icon }}</mat-icon>
              </div>

              <div class="resident-recent-connections__status">
                <span
                  class="resident-connection-status"
                  [ngClass]="'resident-connection-status--' + getResidentConnectionStatus(connection)"
                >
                  {{ 'connectionStatus.' + getResidentConnectionStatus(connection) | loc }}
                </span>
              </div>

              <div class="resident-recent-connections__date">
                {{ connection.createdAt | lDate: 'dMedNoYear' }}, {{ connection.createdAt | lDate: 'tShort' }}
              </div>

              <div class="resident-recent-connections__admin">
                {{ connection.adminPhone }}
              </div>

              <div class="resident-recent-connections__actions">
                <button
                  *ngIf="connection.isOngoing"
                  type="button"
                  class="resident-recent-connections__overlay"
                  (click)="openActiveCallOverlay(connection, $event)"
                >
                  <mat-icon>call</mat-icon>
                  {{ 'connection.openActiveCallOverlay' | loc }}
                </button>
              </div>
            </div>
          </ng-template>
        </app-expandable-list>
      </div>

      <ng-template #noResidentRecentConnections>
        <div class="resident-recent-connections__empty">{{ 'connection.noRecentCalls' | loc }}</div>
      </ng-template>
    </app-details-section>

    <app-details-section headerKey="user.noteList">
      <app-notes [refId]="data.resident.id" [type]="NoteType.LANDLORD" [disableEdit]="!canEdit"></app-notes>
    </app-details-section>

    <app-details-section headerKey="emails.resDetails" *ngIf="anyBasicDataExist">
      <app-users-resident-basic-data
        [data]="data.resident"
        [creator]="data.creator"
        (showOwnerCodes)="showOwnerCodes = true"
      ></app-users-resident-basic-data>
    </app-details-section>

    <app-details-section headerKey="user.emergeContact" *ngIf="data.resident.emergencyContact">
      <app-users-resident-emergency-contact [contact]="data.resident.emergencyContact"></app-users-resident-emergency-contact>
    </app-details-section>

    <app-all-integration-codes [codes]="data.resident.residentCodes" [(show)]="showOwnerCodes"></app-all-integration-codes>

    <app-details-section
      *ngIf="aptResidencyVMs.length"
      [headerKey]="'commApartment.' + (aptResidencyVMs.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links
        [unitsCommunity]="aptResidencyVMs"
        [refResidentId]="data.resident.id"
        [currentTenancies]="data.type == ResidentType.TENANT"
        [residentType]="data.type"
        [type]="RentalUnitType.APARTMENT"
        [dividers]="true"
      ></app-users-rental-units-links>
    </app-details-section>

    <app-details-section
      *ngIf="parkResidencyVMs.length"
      [headerKey]="'parking.' + (parkResidencyVMs.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links
        [unitsCommunity]="parkResidencyVMs"
        [refResidentId]="data.resident.id"
        [currentTenancies]="data.type == ResidentType.TENANT"
        [type]="RentalUnitType.PARKING"
        [dividers]="true"
      ></app-users-rental-units-links>
    </app-details-section>

    <app-details-section
      *ngIf="stoResidencyVMs.length"
      [headerKey]="'storage.' + (stoResidencyVMs.length > 1 ? 'plural' : 'nominative')"
    >
      <app-users-rental-units-links
        [unitsCommunity]="stoResidencyVMs"
        [refResidentId]="data.resident.id"
        [currentTenancies]="data.type == ResidentType.TENANT"
        [type]="RentalUnitType.STORAGE"
        [dividers]="true"
      ></app-users-rental-units-links>
    </app-details-section>

    <app-details-section *ngIf="userData" headerKey="user.mobile">
      <app-users-mobile-user-indicator
        [userData]="userData"
        [personalData]="data.resident"
        [type]="ResidentType.TENANT"
        [canRemove]="canAuth"
      ></app-users-mobile-user-indicator>
    </app-details-section>

    <app-details-section *ngIf="previousTenanciesVMs.length" headerKey="user.accessBef">
      <app-users-comm-tenant-rental-units-links
        [previousTenancies]="previousTenanciesVMs"
        [tenantId]="data.id"
      ></app-users-comm-tenant-rental-units-links>
    </app-details-section>

    <app-details-section *ngIf="showResolutions" headerKey="navigation.resolutions" [last]="true">
      <div class="margin-bottom-10" *ngTemplateOutlet="resolutions; context: { array: yesVotesVMs, type: VoteType.YES }"></div>
      <div class="margin-bottom-10" *ngTemplateOutlet="resolutions; context: { array: noVotesVMs, type: VoteType.NO }"></div>
      <div class="margin-bottom-10" *ngTemplateOutlet="resolutions; context: { array: holdVotesVMs, type: VoteType.HOLD }"></div>
      <div class="margin-bottom-10" *ngTemplateOutlet="resolutions; context: { array: mixedVotesVMs, type: 'mixed' }"></div>
    </app-details-section>

    <div class="padding-bottom-20">
      <mat-expansion-panel *ngIf="data.type == ResidentType.LANDLORD" class="fliko-panel mat-elevation-z0" [expanded]="false">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'label.attachments' | locUpper }}</mat-panel-title>
        </mat-expansion-panel-header>
        <app-details-section *ngFor="let unit of allUnits; let i = index; let last = last" [last]="last">
          <ng-container section-header>
            <span class="mat-caption">
              {{ unitDocsPrefix(i) }} <b>{{ unit | shortNumber }}</b>
            </span>
          </ng-container>
          <app-users-details-files
            [unitId]="unit.id"
            [residentId]="data.resident.id"
            [canEdit]="canEdit"
          ></app-users-details-files>
        </app-details-section>
      </mat-expansion-panel>
    </div>
  </div>
</div>

<ng-template #resolutions let-array="array" let-type="type">
  <mat-expansion-panel class="fliko-panel mat-elevation-z0" [expanded]="false" *ngIf="array.length">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="title vote-type-title">
          <ng-container [ngSwitch]="type">
            <ng-container *ngSwitchCase="VoteType.YES">
              <span class="vote-circle vote-yes"> <mat-icon>thumb_up</mat-icon> </span>
              <b>{{ 'res.votesFor' | locUpper }} ({{ array.length }})</b>
            </ng-container>
            <ng-container *ngSwitchCase="VoteType.NO">
              <span class="vote-circle vote-no"> <mat-icon>thumb_down</mat-icon> </span>
              <b>{{ 'res.votesAgainst' | locUpper }} ({{ array.length }})</b>
            </ng-container>
            <ng-container *ngSwitchCase="VoteType.HOLD">
              <span class="vote-circle vote-hold"> <mat-icon>pan_tool</mat-icon> </span>
              <b>{{ 'res.votesHold' | locUpper }} ({{ array.length }})</b>
            </ng-container>
            <ng-container *ngSwitchCase="'mixed'">
              <span class="vote-circle vote-mixed"> <mat-icon>thumbs_up_down</mat-icon> </span>
              <b>{{ 'res.votesMixed' | locUpper }}! ({{ array.length }})</b>
            </ng-container>
          </ng-container>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngFor="let obj of array; let i = index">
      <div>
        {{ i + 1 }}.
        <a class="clickable" (click)="routeToResolution(obj.resId, obj.resStatus)">
          <u>{{ obj.name }}</u>
        </a>
      </div>
    </ng-container>
  </mat-expansion-panel>
</ng-template>
